import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 43E5E22F-AEEB-406D-BEF3-898BE3C91FC1
 * name skew-less
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skew-less.svg
 * tags
 * - Math 
 */
export const SkewLessIcon = createSvgIcon(<><path d="M17.5,11L15.41,20H10.5L12.59,11H17.5M20,9H11L8,22H17L20,9M4,6L8,2V5H16V7H8V10L4,6Z" /></>, 'SkewLessIcon');
export default SkewLessIcon